"use client";
import { formatSurcharge } from "@/utils/formatSurcharge";
import { Tooltip } from "@clover-web-lib-sprout/tooltip";
import { useTranslations } from "next-intl";

export const Surcharge = ({
  isTimeSlot,
  surchargeRate,
  placement = "bottom",
}: any) => {
  const t = useTranslations("Surcharge");
  const paddingRight = isTimeSlot ? "pr-5" : "";
  const surchargeRoundRate = formatSurcharge(surchargeRate);
  const surchargeText = t("text", {
    surchargeRoundRate,
  });
  const tooltipText = t("tooltip", {
    surchargeRoundRate,
  });

  return (
    <Tooltip
      content={tooltipText}
      label="surcharge-tooltip"
      placement={placement}
      shouldNotWrap
      id={"surcharge-tooltip"}
    >
      <button
        className="relative cursor-pointer h-[22.5px]"
        aria-label={t("toolTipLabel")}
        tabIndex={0}
      >
        <span
          className={`text-[14px] font-medium text-black px-1 mb-2 cursor-pointer underline decoration-dashed ${paddingRight}`}
        >
          {surchargeText}
        </span>
      </button>
    </Tooltip>
  );
};
